module.exports = __webpack_public_path__ + "media/components/assets/vent_03-bc6c55d25f2d090c48c0dda950518ef6.jpg";